// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"89f9f28c","533":"8c31fd10","713":"6790512b","732":"731ec058","943":"7527af36","977":"bfddabe3"}[chunkId] + ".chunk.js";
};